import React, { useRef, useEffect, useState } from 'react';
import { ChevronDown, useAnalytics, useAnalyticsAttributes } from '../../../components';
import { TabGroup, Tab, Link, Underline } from './Tabs.styles';
export function Tabs({ tabs, activeTab, setActiveTab }) {
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    const activeTabRef = useRef(null);
    const [activeTabStyle, setActiveTabStyle] = useState({ width: 0 });
    useEffect(() => {
        if (activeTabRef.current) {
            setActiveTabStyle({
                left: activeTabRef.current.offsetLeft + 16,
                width: activeTabRef.current.clientWidth - 32
            });
        }
        else if (activeTabStyle && activeTabStyle.left) {
            setActiveTabStyle({
                left: activeTabStyle.left,
                width: 0
            });
            setTimeout(() => {
                setActiveTabStyle({ width: 0 });
            }, 300);
        }
    }, [activeTab, activeTabRef]);
    return (React.createElement(TabGroup, null,
        tabs.map((tab, index) => tab.type === 'uiHeaderNavTab' ? (React.createElement(Tab, { "aria-expanded": activeTab === index, "data-active": activeTab === index, "data-testid": "bignav-tab", key: index, onClick: (e) => {
                if (activeTab === index) {
                    setActiveTab(undefined);
                }
                else {
                    sendTrackEvent('clickedGlobalNavTab', Object.assign(Object.assign({}, analyticsAttributes), { event: 'clicked', eventComponent: 'globalNavTab', label: tab.content.title, labelEnglish: tab.content.entryTitle, uuid: tab.id }));
                    setActiveTab(index);
                }
                e.stopPropagation();
            }, ref: activeTab === index ? activeTabRef : null },
            tab.content.title,
            React.createElement(ChevronDown, null))) : (React.createElement(Link, { href: tab.content.url, key: index, onClick: () => sendTrackEvent('clickedGlobalNavLink', Object.assign(Object.assign({}, analyticsAttributes), { event: 'clicked', eventComponent: 'globalNavLink', label: tab.content.text, labelEnglish: tab.content.entryTitle, href: tab.content.url, uuid: tab.id })) }, tab.content.text))),
        React.createElement(Underline, { style: activeTabStyle })));
}
//# sourceMappingURL=Tabs.js.map